
/* Dojo Eats: cart checkout fallback.
   Product Buy Now buttons are left to their own section handlers. */
(function () {
  'use strict';

  if (window.__dojoCartCheckoutFallback) return;
  window.__dojoCartCheckoutFallback = true;

  function shopifyRoot() {
    return (window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root) || '/';
  }

  function checkoutUrl() {
    return shopifyRoot().replace(/\/?$/, '/') + 'checkout';
  }

  function isCartCheckout(button) {
    if (!button) return false;

    if (button.id === 'checkout' &&
        button.name === 'checkout' &&
        button.getAttribute('form') === 'cart-form') {
      return true;
    }

    const form = button.form ||
      (button.getAttribute('form')
        ? document.getElementById(button.getAttribute('form'))
        : null);

    if (button.name === 'checkout' && form) {
      const path = new URL(form.action, location.origin).pathname
        .replace(/\/+$/, '');

      if (form.id === 'cart-form' || path.endsWith('/cart')) {
        return true;
      }
    }

    return !!button.closest(
      '#CartDrawer, #cart-drawer, [id*="CartDrawer"], ' +
      'cart-drawer, cart-drawer-component, .cart-drawer'
    ) && button.name === 'checkout';
  }

  document.addEventListener('click', function (event) {
    const target = event.target instanceof Element
      ? event.target
      : event.target && event.target.parentElement;

    if (!target) return;

    const button = target.closest(
      '#checkout, button[name="checkout"], input[name="checkout"]'
    );

    if (!button || !isCartCheckout(button)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(checkoutUrl());
  }, true);

  console.info('[Dojo] Cart checkout fallback loaded.');
})();
